import { render, staticRenderFns } from "./HeaderChildMenu.vue?vue&type=template&id=97234dc0&"
import script from "./HeaderChildMenu.vue?vue&type=script&lang=js&"
export * from "./HeaderChildMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports